import React, { useEffect, useRef, useState } from 'react';
import { Input } from 'reactstrap';
import { ExpandedText } from '../../DataRequest/ExpandedText/ExpandedText';

const COMMENT_MAX_LENGTH = 2000;

const COMMENT_CLAMP_LINES = 3;
const COMMENT_HEIGHT_PX = 54;

export interface LegalTermCommentCellProps {
    value: string | null;
    editable: boolean;
    uniqueId: string;
    onSave: (comment: string | null) => Promise<void>;
}

export const LegalTermCommentCell = (props: LegalTermCommentCellProps) => {
    const { value, editable, uniqueId, onSave } = props;
    const [draft, setDraft] = useState(value ?? '');
    const [isSaving, setIsSaving] = useState(false);
    const savedValueRef = useRef(value ?? '');
    const isFocusedRef = useRef(false);

    useEffect(() => {
        if (!isFocusedRef.current) {
            setDraft(value ?? '');
            savedValueRef.current = value ?? '';
        }
    }, [value]);

    if (!editable) {
        return value ? (
            <ExpandedText
                content={value}
                uniqueId={uniqueId}
                heightToShowLinksPx={COMMENT_HEIGHT_PX}
                clampLines={COMMENT_CLAMP_LINES}
                className="loi-form-comment-readonly"
            />
        ) : null;
    }

    const handleBlur = async () => {
        isFocusedRef.current = false;
        if (draft === savedValueRef.current) {
            return;
        }
        const nextComment = draft === '' ? null : draft;
        setIsSaving(true);
        const isSaved = await onSave(nextComment).then(
            () => true,
            () => false
        );
        if (isSaved) {
            savedValueRef.current = draft;
        }
        setIsSaving(false);
    };

    return (
        <Input
            type="textarea"
            value={draft}
            disabled={isSaving}
            aria-label="Comment"
            maxLength={COMMENT_MAX_LENGTH}
            onFocus={() => {
                isFocusedRef.current = true;
            }}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={handleBlur}
            className="form-control loi-form-input loi-form-comment-input"
        />
    );
};

export default LegalTermCommentCell;
